import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BiEdit } from "react-icons/bi";
import { Select } from "antd";
import { FiCheckCircle } from "react-icons/fi";
import { RiSearchLine } from "react-icons/ri";

import AntdTable from "../../components/Table/Table";
import "../..//styles/forms.css";
import { useDispatch, useSelector } from "react-redux";
import { setAllForms, setCurrentForm } from "../../redux/actions/forms";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  ALL_SURVEYORS,
  GET_FORMS,
  GET_SURVEYOR_FORMS,
} from "../../GraphQl/Queries";
import { roles } from "../../constants/Roles";
import {
  ASSIGN_SURVEYOR_FORM,
  UPDATE_FORM_METADATA_UPDATE_MUTATION,
} from "../../GraphQl/Mutations";
import { FaLink, FaSpinner } from "react-icons/fa";
import Loader from "../../components/Loader";
import { AiOutlineReload } from "react-icons/ai";
const FormRequests = () => {
  const [PageSize, setPageSize] = useState(8);

  const [data, setData] = useState([]);
  const [message, setMessage] = useState(null);
  const [localForms, setLocalForms] = useState([]);
  const [adminList, setAdminList] = useState([]);
  const [currentAdmin, setCurrentAdmin] = useState({
    record: null,
    admin: null,
  });
  const [getForms, allForms] = useLazyQuery(GET_SURVEYOR_FORMS, {
    fetchPolicy: "cache-and-network",
    onCompleted: (res) => {
      setData(res?.getRequestedForms);
      setLocalForms(res?.getRequestedForms);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const [getAllAdminList, { load }] = useLazyQuery(ALL_SURVEYORS, {
    fetchPolicy: "cache-first",
    variables: {
      userType: roles.ADMIN,
    },
    onCompleted: (data) => {
      setAdminList(
        data.getAllUsers?.map((data) => {
          return {
            value: data.email,
            label: data?.fullName + " " + data?.email,
          };
        })
      );
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const [assignAdmin, assignedAdmin] = useMutation(ASSIGN_SURVEYOR_FORM, {
    onCompleted: () => {
      getForms();
      getAllAdminList();
    },
    onError: (err) => {
      setMessage(err?.message);
    },
  });

  const [paginateStatus, setPaginateStatus] = useState({
    current: 1,
    pageSize: PageSize,
  });

  const columns = [
    {
      title: "Surveyor",
      dataIndex: "Surveyor",
      key: "Surveyor",
      width: "16.66%",
      render: (text, record) => (
        <div className='flex flex-col items-start content-start'>
          <span className='surveyorName'>
            {record?.requestedSurveyor?.fullName}
          </span>
          <span className='surveyorEmail'>
            {record?.requestedSurveyor?.email}
          </span>
        </div>
      ),
    },
    {
      title: "Assign To",
      dataIndex: ["adminDetails", "fullName"],
      key: ["adminDetails", "fullName"],
      width: "5%",
      render: (text, record) => (
        <Select
          style={{ width: "min(200px,60vw)" }}
          defaultValue={record?.assignedAdmin}
          styles={styles}
          options={adminList}
          showSearch
          placeholder='Select an admin'
          optionFilterProp='children'
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          onChange={(e) => setCurrentAdmin({ record: record?._id, admin: e })}
        />
      ),
    },
    {
      title: "Form Title",
      width: "12.66%",
      dataIndex: "formTitle",
    },
    {
      title: "Form Type",
      width: "12.66%",
      dataIndex: "formType",
    },
    {
      title: "Mobile Number",
      width: "12.66%",
      render: (text, record) => (
        <span className='form'>
          {record?.requestedSurveyor?.phone || "Unavailable"}
        </span>
      ),
    },

    {
      title: "Action",
      width: "16.66%",
      render: (text, record) => (
        <>
          {record?.assignedAdmin ? (
            <div
              className='SurveyorFormAction'
              style={{
                background: "#007bff",
                pointerEvents: "none",
                cursor: "not-allowed",
                color: "#fff",
              }}
            >
              {assignedAdmin?.loading ? (
                <Loader color='#111' />
              ) : (
                <FiCheckCircle />
              )}
              &nbsp; Task Assigned
            </div>
          ) : (
            <div
              className='SurveyorFormAction'
              onClick={(e) => {
                assignAdmin({
                  variables: {
                    assignAdminFormId: record?._id,
                    adminEmail: currentAdmin?.admin,
                  },
                });
                setCurrentAdmin({ record: null, admin: null });
              }}
            >
              &nbsp;{" "}
              {assignedAdmin?.loading ? (
                <Loader color='#111' />
              ) : (
                <FiCheckCircle />
              )}{" "}
              Assign Task
            </div>
          )}
        </>
      ),
    },
  ];

  useEffect(() => {
    getForms();
    getAllAdminList();
    if (load) setAdminList({ value: null, label: <Loader /> });
  }, []);

  const styles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      width: "100%",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
    }),
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
  };

  const handleChange = (e) => {
    var value = e.target.value.toLowerCase();
    var searchArray = localForms?.filter(
      (item) =>
        item?.requestedSurveyor?.fullName?.toLowerCase()?.includes(value) ||
        item?.requestedSurveyor?.email?.toLowerCase()?.includes(value) ||
        item?.requestedSurveyor?.phone?.toLowerCase()?.includes(value)
    );
    if (searchArray.length > 0) {
      setData(searchArray);
    } else if (searchArray.length == 0) {
      setData(localForms);
    }
  };

  return (
    <section className='manageFormWrapper'>
      <div className='sectionHeaderWrapper flex items-center content-between'>
        <div className='sectionHeaderTitle'> Manage Surveyor Forms </div>
      </div>
      <div className='sectionContentWrapper'>
        {message && <div className='messageDiv'>{message}</div>}

        <>
          <div className='sectionHeaderWrapper flex items-center content-between mt-0'>
            <form
              className='searchForm col-md-8'
              onSubmit={(e) => e.preventDefault()}
            >
              <button type='submit'>
                <RiSearchLine />
              </button>
              <input
                type='text'
                placeholder='Search for names, emails, numbers'
                onKeyUp={(e) => handleChange(e)}
              />
            </form>
            <button className='btn btn-primary w-auto' onClick={getForms}>
              {allForms?.loading || load ? (
                <Loader color='#fff' />
              ) : (
                <AiOutlineReload />
              )}
            </button>
          </div>
          <AntdTable
            columns={columns}
            dataSource={data}
            scroll={{
              x: "auto",
            }}
            loading={allForms?.loading}
            pagination={{
              defaultCurrent: paginateStatus.current,
              pageSize: PageSize,
            }}
            onChange={(pagination, e) => {
              setPaginateStatus(pagination);
              setPageSize(pagination?.pageSize);
            }}
            sticky
          />
        </>
      </div>
    </section>
  );
};

export default FormRequests;
